import React from 'react';
import { Button } from '../../components/ui/button';
import { Plane, Hotel, Car, Loader2 } from 'lucide-react';
import { LinkGroup } from '../copilot/CopilotParts';

export const CopilotTravel = ({ getTravelLinks, travel, travelLoading }) => (
        <div>
          <Button onClick={getTravelLinks} disabled={travelLoading} variant="outline" className="w-full text-sm">
            {travelLoading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Plane className="w-4 h-4 mr-2" />}
            Generate travel & hotel booking links
          </Button>
          {travel && (
            <div className="mt-3 space-y-2">
              <p className="text-xs text-slate-500">
                Destination: <span className="font-semibold text-slate-700 dark:text-slate-300">{travel.destination_city} ({travel.nearest_airport})</span>
                {' · '}Suggested stay: {travel.check_in} → {travel.check_out}
              </p>
              <LinkGroup icon={Plane} title="Flights" links={travel.flights} />
              <LinkGroup icon={Hotel} title="Hotels" links={travel.hotels} />
              <LinkGroup icon={Car} title="Transfers" links={travel.transfers} />
              <p className="text-[10px] text-slate-400 italic">{travel.disclaimer}</p>
            </div>
          )}
        </div>
);
